<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="isKeep" :key="viewKey" />
    </keep-alive>
    <router-view v-if="!isKeep" />
  </div>
</template>

<script>
// @ is an alias to /src
import './assets/less/common.less';

export default {
  name: 'Home',
  computed:{
    isKeep(){
      return this.$route.meta.keepAlive
    },
    viewKey(){
      return this.$route.params.album
    }
  }
}
</script>